/**
 * SPDX-FileCopyrightText: 2025 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
import Vue from 'vue';
import Setup from './views/Setup.vue';
const SetupVue = Vue.extend(Setup);
new SetupVue().$mount('#content');
